import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import UnboxingDetailsTemplate from '../components/templates/UnboxingDetails';

function UnboxingDetails() {
  return <AuthWrapper renderProps={UnboxingDetailsTemplate} />;
}

export default UnboxingDetails;
